var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 883,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 884,
	"./assets/thewest-digital-hero-variation-a.jpg": 2965,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 885,
	"./assets/thewest-digital-hero-variation-b.jpg": 2966,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 886,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2967,
	"./assets/thewest-digital-hero-variation-eofy-mobile.jpg": 887,
	"./assets/thewest-digital-hero-variation-eofy.jpg": 2968,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 888,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2969,
	"./assets/thewest-digital-hero-variation-footy-lives-here-mobile.jpg": 889,
	"./assets/thewest-digital-hero-variation-footy-lives-here.jpg": 2970,
	"./assets/thewest-digital-hero-variation-summer-of-cricket-mobile.jpg": 890,
	"./assets/thewest-digital-hero-variation-summer-of-cricket.jpg": 2971,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 891,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2972,
	"./assets/thewest-digital-hero.jpg": 2973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 615;